import { templatesIcons as t } from "../../../data/mock.js";
import { FORMA_FOLDER_ID_STATIC as l, FORMA_FOLDER_ID_PACKS as i, FORMA_FOLDER_ID_TRASH as f } from "../../../data/constants.js";
const u = (r, o) => {
  var s, e;
  return r.type === "folder" ? r.external ? r.id === l ? t.list.folders.static : r.id === i ? t.list.folders.packs : r.id === f ? t.list.folders.trash : t.list.folders.strict : (s = r.children) != null && s.length ? r.isAccessAdd || (e = r.groups) != null && e.length ? t.list.folders.private : t.list.folders.default : t.list.folders.empty : r.external ? t.list.files.strict : t.list.files.default;
};
export {
  u as getListItemIcon
};
